export const CHECKED_CART_IDS_STORAGE_KEY = 'voo-checkedIds';

export function normalizeCheckedCartIds(ids?: Array<number | string | null | undefined>): number[] {
  return Array.from(
    new Set((ids || []).map((id) => Number(id)).filter((id) => !Number.isNaN(id) && id > 0)),
  );
}

export function readCheckedCartIdsFromSession(): number[] {
  if (process.server) return [];
  try {
    const value = sessionStorage.getItem(CHECKED_CART_IDS_STORAGE_KEY);
    if (!value) return [];
    const parsed = JSON.parse(value);
    return normalizeCheckedCartIds(Array.isArray(parsed) ? parsed : []);
  } catch (error) {
    console.log(error);
  }
  return [];
}

export function writeCheckedCartIdsToSession(
  ids?: Array<number | string | null | undefined>,
): void {
  if (process.server) return;
  const checkedIds = normalizeCheckedCartIds(ids);
  if (checkedIds.length) {
    sessionStorage.setItem(CHECKED_CART_IDS_STORAGE_KEY, JSON.stringify(checkedIds));
  } else {
    sessionStorage.removeItem(CHECKED_CART_IDS_STORAGE_KEY);
  }
}

export function clearCheckedCartIdsSession(): void {
  if (process.server) return;
  sessionStorage.removeItem(CHECKED_CART_IDS_STORAGE_KEY);
}
